export function validateSpaces(value, fieldName = "This field") {
  if (!value || !value.trim()) {
    return `${fieldName} is required`;
  }

  if (/^\s/.test(value) || /\s$/.test(value)) {
    return `${fieldName} cannot have leading or trailing spaces`;
  }

  if (/\s{2,}/.test(value)) {
    return `${fieldName} cannot have multiple spaces between words`;
  }

  return "";
}
